/**
 * Created by Jie Gao on 2018-11-09.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {FreespinFeatureEvent} from "./events/FreespinFeatureEvent";

export interface IWildMeter {
    sprite:PIXI.Sprite;
    gemEffect:TimelineSprite;
    symbol:TimelineSprite;
    gems:PIXI.Sprite[];
}

export class FSWildMeterView extends BaseView {
    protected _nextGemBlink:PIXI.Sprite;
    protected _meterSymbolChangeEffect:TimelineSprite;
    protected _symbolSprites:IWildMeter[] = [];
    protected _wrapper:PIXI.Sprite;
    protected _config:any;
    protected _symbolValues:number[];
    private _symbolEffectOffset:number = 77;
    private _xOffset:number = 0;
    private _nextGemBlinkTl:TimelineLite;
    private _transformedX:number[] = [0, 0];
    private _transformedY:number[] = [0, 0];
    private _stageTween:TweenLite;

    constructor(config:any) {
        super();
        this._config = config;
        this._symbolValues = ArrayHelper.initArrayWithValues(this._config.symbols.length, (i:number) => {
            return (i === 0 ? 0 : -1);
        });
        //this.show();
    }

    public show(symbolValues:number[], isRestoreFreespin:boolean):void {
        StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.FOREGROUND.name).addChild(this);
        const tl:TimelineLite = new TimelineLite();
        this._nextGemBlinkTl = new TimelineMax({repeat : -1, paused : true});
        this._nextGemBlinkTl.to(this._nextGemBlink, 0.3, {alpha : 1}).to(this._nextGemBlink, 0.2, {alpha : 0});
        this._stageTween = TweenLite.fromTo(StageManager.stage, 3, {
            x : "+=" + this._transformedX[0],
            y : "+=" + this._transformedY[0]
        }, {x : NolimitApplication.screenBounds.left, y : NolimitApplication.screenBounds.top});
        tl.add([
            () => this._stageTween.play(),
            TweenLite.fromTo(StageManager.stage.scale, 3, {x : 0.8, y : 0.8}, {x : 1, y : 1})
        ]);
        if(!isRestoreFreespin) {
            this._symbolSprites.forEach((sprite:IWildMeter, i:number) => {
                tl.add([
                    () => {
                        this._meterSymbolChangeEffect.position.set(this._symbolSprites[i].sprite.x + this._symbolEffectOffset, this._symbolSprites[i].sprite.y + this._symbolEffectOffset);
                        SlotGame.sound.playEffect((<any>DragonTribeSoundConfig)[`FS_METER_FIRE_${i % 2}`]);
                    },
                    this._meterSymbolChangeEffect.getAnimationAutoShowHide(true, true),
                    TweenLite.fromTo(sprite.sprite, 0.67, {alpha : 0}, {alpha : 1}),
                    TweenLite.fromTo(sprite.sprite.scale, 0.67, {x : 1.5, y : 1.5}, {x : 1, y : 1}),
                    TweenLite.fromTo(this._meterSymbolChangeEffect.scale, 0.67, {x : 1.5, y : 1.5}, {x : 1, y : 1})
                ], "-=0.5");
            });
            this.updateGems(tl, symbolValues);
        }
        tl.add(() => {
            if(symbolValues[0] <= 14) {
                this._nextGemBlink.visible = true;
                this._wrapper.addChild(this._nextGemBlink);
                this._nextGemBlinkTl.play(0);
            }
            EventHandler.dispatchEvent(new GameEvent(FreespinFeatureEvent.METER_SHOWN));
        })

    }

    public hide():void {
        this.hideGemBlink();
        StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.FOREGROUND.name).removeChild(this);
        this.reset();
    }

    //TODO:
    public updateGems(tl:TimelineLite, symbolValues:number[], isInit:boolean = false):void {
        this._symbolValues = symbolValues;
        if(symbolValues[0] > 14) {
            this.hideGemBlink();
            return;
        }
        const gemDiff:number = isInit ? 0 : 1;
        const gemShineX:number = Math.floor((symbolValues[0] - 1) / 3);
        const gemShineY:number = Math.floor((symbolValues[0] - 1) % 3);
        if(!(symbolValues[0] == 0 || isInit)) {
            tl.add([
                () => {
                    this._symbolSprites[gemShineX].gemEffect.position.x = 25 * gemShineY;
                    this._meterSymbolChangeEffect.position.set(this._symbolSprites[gemShineX].sprite.x + this._symbolEffectOffset, this._symbolSprites[gemShineX].sprite.y + this._symbolEffectOffset);
                    SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_METER_FIRE_0);
                },
                this._meterSymbolChangeEffect.getAnimationAutoShowHide(true, true)
            ]);
            tl.add([
                () => {SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_METER_LIGHT);},
                this._symbolSprites[gemShineX].gemEffect.getAnimationAutoShowHide(true, true)
            ]);
            tl.add(() => {this._symbolSprites[gemShineX].gems[gemShineY].texture = GameResources.getTextures("gem")[0]});
        }
        this._symbolSprites.forEach((symbolSprite:IWildMeter, i:number) => {
            symbolSprite.gems.forEach((gem:PIXI.Sprite, j:number) => {
                gem.texture = GameResources.getTextures(((symbolValues[i] - gemDiff) > j) ? "gem" : "gem_null")[0];
            });
            if(symbolValues[i] >= 0 && symbolValues[i] <= 2) {
                tl.add(() => {
                    this._nextGemBlink.position.set(symbolSprite.sprite.x + symbolSprite.gems[symbolValues[i]].position.x, symbolSprite.sprite.y + symbolSprite.gems[symbolValues[i]].position.y);
                });
            }
        });

    }

    public hideGemBlink():void {
        this._nextGemBlink.visible = false;
        if(this._nextGemBlinkTl && this._nextGemBlinkTl.isActive()) {
            this._nextGemBlinkTl.pause();
            this._nextGemBlinkTl.kill();
        }
    }

    public updateSymbolAnimation(tl:TimelineLite, id:number, withAnimation:boolean):void {
        const symbolSprite:IWildMeter = this._symbolSprites[id];
        tl.add(() => {
            symbolSprite.gems.forEach((gem:PIXI.Sprite) => {
                gem.alpha = 0;
            });
        });
        if(withAnimation) {
            tl.add([
                () => {SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_METER_TO_WILD);},
                symbolSprite.symbol.getAnimationAutoShowHide(true, false)
            ]);
        } else {
            tl.add(symbolSprite.symbol.getAnimation([-1, -1]));
        }
    }

    public reset():void {
        this._symbolSprites.forEach((symbolSprite:IWildMeter, i:number) => {
            symbolSprite.sprite.alpha = 0;
            symbolSprite.symbol.getAnimation([0, 0]);
            symbolSprite.gems.forEach((gem:PIXI.Sprite) => {
                gem.alpha = 1;
                gem.texture = GameResources.getTextures("gem_null")[0];
            });
        });
    }

    protected initAnimations():void {
        this._wrapper = new PIXI.Sprite();
        this._nextGemBlink = new PIXI.Sprite(GameResources.getTextures("gem_next")[0]);
        this._nextGemBlink.blendMode = PIXI.BLEND_MODES.ADD;
        this._nextGemBlink.alpha = 0;
        this._meterSymbolChangeEffect = new TimelineSprite(GameResources.getTextures("meterSymbolChangeEffect"));
        this._meterSymbolChangeEffect.anchor.set(0.5, 0.5);
        this._meterSymbolChangeEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._meterSymbolChangeEffect.hide();

        this._wrapper.addChild(this._nextGemBlink);
        this.addChild(this._wrapper);
        this._symbolSprites = ArrayHelper.initArrayWithValues(this._config.symbols.length, (i:number) => {
            return this.createSymbolContainer(i);
        });
        this._wrapper.addChild(this._meterSymbolChangeEffect);
    }

    protected createSymbolContainer(i:number):IWildMeter {
        const sprite:PIXI.Sprite = new PIXI.Sprite();
        const symbol:TimelineSprite = new TimelineSprite(GameResources.getTextures("icon_" + this._config.symbols[i]));
        const gemEffect:TimelineSprite = new TimelineSprite(GameResources.getTextures("addGemEffect"));
        const gem0:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("gem_null")[0]);
        const gem1:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("gem_null")[0]);
        const gem2:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("gem_null")[0]);

        symbol.getAnimation([0, 0]);
        symbol.anchor.set(0.5, 0.5);
        symbol.position.set(symbol.width / 2, symbol.height / 2);

        gemEffect.blendMode = PIXI.BLEND_MODES.ADD;
        gemEffect.hide();
        gemEffect.position.set(50, 63);

        gem0.position.set(29, 95);
        gem1.position.set(54, 95);
        gem2.position.set(79, 95);
        sprite.addChild(symbol);
        sprite.addChild(gem0);
        sprite.addChild(gem1);
        sprite.addChild(gem2);
        sprite.addChild(gemEffect);
        this._wrapper.addChild(sprite);
        return {
            sprite : sprite,
            symbol : symbol,
            gemEffect : gemEffect,
            gems : [gem0, gem1, gem2]
        };
    }

    protected onResize(data:IResizeData):void {
        if(this._stageTween && this._stageTween.isActive()) {
            this._stageTween.pause();
            this._stageTween.kill();
            if(StageManager.legacyScaling) {
                StageManager.stage.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
            }
        }

        this._xOffset = (data.orientation === Orientation.PORTRAIT) ? (DragonTribeGameConfig.instance.SYMBOL_WIDTH * 0.35 * 0.5) : 120;
        const width:number = DragonTribeGameConfig.instance.SYMBOL_WIDTH;
        const x0:number = Helper.getSymbolPositions(0, 5)[0];
        if(data.orientation === Orientation.PORTRAIT) {
            this._transformedX = [40, 0];
            this._transformedY = [100, 10];
            const isIPad:boolean = data.width / data.height >= 0.73;
            const scale:number = (isIPad ? 0.8 : 1);
            this._wrapper.scale.set(scale, scale);
            this._wrapper.x = x0 - width * 0.6 + (isIPad ? 78 : 15);
            this._wrapper.y = GameConfig.instance.REEL_AREA_POS_Y + DragonTribeGameConfig.instance.REEL_AREA_TOP - (isIPad ? 180 : 205);
            this._symbolSprites.forEach((symbolSprite:IWildMeter, i:number) => {
                symbolSprite.sprite.scale.set(1, 1);
                symbolSprite.sprite.x = 25 + i * 122;
                symbolSprite.sprite.y = 0;
                if(this._symbolValues[i] >= 0 && this._symbolValues[i] <= 2) {
                    this._nextGemBlink.position.set(symbolSprite.sprite.x + symbolSprite.gems[this._symbolValues[i]].position.x, symbolSprite.sprite.y + symbolSprite.gems[this._symbolValues[i]].position.y);
                }
            });
            return;
        }
        this._transformedX = [130, 0];
        this._transformedY = [100, 20];
        this._wrapper.x = x0 - 278;
        this._wrapper.y = 10;
        this._symbolSprites.forEach((symbolSprite:IWildMeter, i:number) => {
            symbolSprite.sprite.scale.set(1, 1);
            symbolSprite.sprite.x = 0;
            symbolSprite.sprite.y = i * 110;
            if(this._symbolValues[i] >= 0 && this._symbolValues[i] <= 2) {
                this._nextGemBlink.position.set(symbolSprite.sprite.x + symbolSprite.gems[this._symbolValues[i]].position.x, symbolSprite.sprite.y + symbolSprite.gems[this._symbolValues[i]].position.y);
            }
        });

        if(!UserAgent.isMobile) {
            return;
        }
        this._wrapper.x = data.isLeftHanded ? 1000 : (x0 - 255);
    };
}